import React, { useEffect, useState } from "react";
import { useRegisterMutation } from "../../features/AuthApi/authApi";
import logo2 from "../../image/learningportal.svg";
import { useNavigate } from "react-router-dom";
const StudentRegistration = () => {
  const [cpass, setCpass] = useState("");
  const [error, setError] = useState("");
  const [formData, setData] = useState({
    email: "",
    password: "",
    role: "student",
    name: "",
  });

  const changeHandler = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    setData({ ...formData, [name]: value });
  };
  const [register, { data, isLoading, error: resError }] =
    useRegisterMutation();

  const navigate = useNavigate();

  useEffect(() => {
    if (resError?.data) {
      setError(resError?.data);
    }
    if (data?.accessToken && data?.user) {
      navigate("/courseplayer");
    }
    console.log(data);
    console.log(resError);
  }, [data, resError, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (cpass !== formData.password) {
      setError("Passwords do not match");
    } else {
      register(formData);
    }
  };

  return (
    <section className="py-6 bg-primary h-screen grid place-items-center">
      <div className="mx-auto max-w-md px-5 lg:px-0">
        <div>
          <img className="h-12 mx-auto" src={logo2} alt="logo2" />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
            Create Your New Account
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label for="name" className="sr-only">
                Name
              </label>
              <input
                id="name"
                name="name"
                type="name"
                autocomplete="name"
                required
                className="login-input rounded-t-md"
                placeholder="Student Name"
                value={formData.name}
                onChange={changeHandler}
              />
            </div>
            <div>
              <label for="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autocomplete="email"
                required
                className="login-input "
                placeholder="Email address"
                value={formData.email}
                onChange={changeHandler}
              />
            </div>
            <div>
              <label for="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autocomplete="current-password"
                required
                className="login-input"
                placeholder="Password"
                value={formData.password}
                onChange={changeHandler}
              />
            </div>
            <div>
              <label for="confirm-password" className="sr-only">
                Confirm Password
              </label>
              <input
                id="confirm-password"
                name="confirm-password"
                type="password"
                autocomplete="confirm-password"
                required
                className="login-input rounded-b-md"
                placeholder="Confirm Password"
                value={cpass}
                onChange={(e) => setCpass(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
              disabled={isLoading}
            >
              Create Account
            </button>
          </div>
          {error !== "" && <span>{error}</span>}
        </form>
      </div>
    </section>
  );
};

export default StudentRegistration;
